import { CognitoAuth } from '@classgo/shared/auth';

import { config } from './config';

/**
 * The one Cognito wrapper of the app (web SRP client). Tokens are not kept by the SDK: the
 * session store holds them.
 */
export const cognito = new CognitoAuth(config.cognito);
